import {useAsyncRetry} from 'react-use';

import {getReportLine} from "@/api/reportLine";

export function useReportLine(userId) {
    return useAsyncRetry(async () => {
        if (!userId) {
            return {data: null};
        }
        return await getReportLine(userId);
    }, [userId]);
}
